import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { OpenIDConnectService } from '@services/auth/openid-connect.service';

@Component({
  selector: 'app-signin-oidc',
  templateUrl: './signin-oidc.component.html',
  styleUrls: ['./signin-oidc.component.scss']
})
export class SigninOidcComponent implements OnInit {
  constructor(private readonly openIDConnectService: OpenIDConnectService, private readonly router: Router) {}

  ngOnInit() {
    this.openIDConnectService.userLoaded$.subscribe(userLoaded => {
      if (userLoaded) {
        this.router.navigate(['']);
      } else {
        if (!environment.production) {
          console.log(`An error happened: user wasn't loaded`);
        }
      }
    });

    this.openIDConnectService.handleCallBack();
  }
}
